module.exports = __webpack_public_path__ + "android-icon-192x192.b744be51.png";